import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=e87e21e4"
import script from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleInfo.vue?vue&type=style&index=0&id=e87e21e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports